import { deriveMaterial } from 'Pods/ThreeDStudio/Shared/Utils/deriveMaterial'
import { getAssetByTypeAndSource } from 'Pods/ThreeDStudio/Shared/Utils/getAssetByTypeAndSource'
import { ACTION, PROVIDER } from 'Pods/ThreeDStudio/Store/constants'

import { getModelFormatOutput } from './getModelFormatOutput'
import { normalizeRunAttributes } from './normalizeRunAttributes'

/**
 * Builds the ThreeDStudio store patch for a Meshy text-to-3d-pro run.
 * Maps polyCount/topology from the run attributes, derives material from
 * enablePbr/geometryOnly (geometry_only -> GEOMETRY_ONLY, enable_pbr ->
 * PBR, both falsy -> BASIC), and opens the model settings panel.
 *
 * @param {Object} openedModel - Run object from the library
 * @returns {Object} parsedData - ThreeDStudio store patch
 */
export const parseMeshyTextTo3dProData = (openedModel) => {
  const {
    id: sessionId,
    generatorSessionId,
    modelFormatOutput: rawModelFormatOutput,
    enablePbr,
    geometryOnly,
    prompt,
    outputAssets,
    private: isPrivate,
    useCase,
  } = openedModel

  const {
    targetPolycount,
    topology: polygonType,
  } = normalizeRunAttributes(openedModel.providerRunAttributes)
  const material = deriveMaterial(enablePbr, geometryOnly)
  const {
    assetId: inputThreeD,
    fileUrl: inputThreeDUrl,
  } = getAssetByTypeAndSource(outputAssets, '3d_model', 'ai_generated')
  const modelFormatOutput = getModelFormatOutput({
    modelFormatOutput: rawModelFormatOutput,
    modelUrl: inputThreeDUrl,
  })
  const generationProvider = PROVIDER.MESHY
  const generationAction = ACTION.TEXT_TO_3D
  const isSmartLowPoly = false

  const schema = { generationAction, generationProvider }
  const generation = { sessionId, generatorSessionId }
  const modelSettings = {
    material,
    targetPolycount,
    polygonType,
    isPrivate,
    isSmartLowPoly,
    prompt,
    selectedUseCase: useCase,
  }
  const viewer = { fileFormat: modelFormatOutput, inputThreeD, material }
  const ui = {
    isModelSettingsOpen: true,
    isViewerSidebarOpen: false,
    activeViewerSidebarTab: undefined,
  }

  return {
    openedModel,
    schema,
    modelSettings,
    ui,
    generation,
    viewer,
  }
}
